import { createFileRoute } from '@tanstack/react-router';

import { AdminDashboardView } from 'src/sections/admin/dashboard/view';

export const Route = createFileRoute('/admin-skidog/dashboard')({
  component: AdminDashboardPage,
});

function AdminDashboardPage() {
  return <AdminDashboardView />;
}
